import { PayloadAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';
import { StatusUpdatesAPI, StatusUpdateState } from 'api/status-updates';
import { putStatusUpdates, ChangeStatusUpdatesPayload } from '../actions';
import { updateStatusUpdate } from '../slice';

function* updateStatusUpdatesManager(
  action: PayloadAction<ChangeStatusUpdatesPayload>,
) {
  const { payload } = action;

  try {
    if (
      payload.statusUpdate?.state !== StatusUpdateState.Published ||
      payload.ccUpdate
    ) {
      const response = yield StatusUpdatesAPI.updateStatusUpdate(
        payload.statusUpdate,
      );

      yield put(updateStatusUpdate(response));
      yield payload.onSuccess && payload.onSuccess(response);
    }
  } catch {
    // TODO
  }
}
export const watchUpdateStatusUpdates = function* () {
  yield takeLatest(putStatusUpdates.type, updateStatusUpdatesManager);
};
